import { useState } from 'react';

import {
  AgentSelector,
  createAgentChatConfig,
  GatewayChatLayout,
  useGatewayChatPage,
} from '@verantos-dev/feature-agent-chat';
import type { SuggestedAction } from '@verantos-dev/shared-components';
import { ProviderType } from '@verantos-dev/types-common';

export const AgentTestClientPage = () => {
  const [selectedAgent, setSelectedAgent] = useState<ProviderType>(ProviderType.OMOP_MAPPING);

  const { layoutProps } = useGatewayChatPage({
    baseOptions: createAgentChatConfig({
      provider: () => selectedAgent,
      isOwner: true,
    }),
    titleFallback: 'Agent test client',
    disclaimerText: 'Experimental workflow for agent test client. Validate results before use.',
    showProtocolMonitor: true,
    suggestedActionsBuilder: ({ setPrompt }) => {
      const makeAction = (id: string, label: string, value: string): SuggestedAction => ({
        id,
        label,
        onClick: () => setPrompt(value),
      });

      return [
        makeAction(
          'omop-validate-codes',
          'OMOP: Validate codes',
          'Validate these codes: J45.8,ICD10, 195967001,SNOMED'
        ),
        makeAction(
          'omop-vocabularies',
          'OMOP: Supported vocabularies',
          'What vocabularies do you support?'
        ),
      ];
    },
  });

  return (
    <GatewayChatLayout
      {...layoutProps}
      chatWindowProps={{
        ...layoutProps.chatWindowProps,
        headerRightContent: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <AgentSelector selectedAgent={selectedAgent} onAgentChange={setSelectedAgent} />
          </div>
        ),
      }}
    />
  );
};

export default AgentTestClientPage;
